Ext.define('SA.VectorMapExportCropPreview', {
    alias: 'widget.vector-map-export-crop-preview',
    extend: 'Ext.container.Container',

    cls: 'sa-export-preview',
    layout: 'fit',
    padding: 30,

    initComponent() {
        this.refresh = SA.createBuffered(this.refresh, 10);

        this.items = [{
            xtype: 'vector-map-export-crop-preview-map',
            extent: this.extent,
            model: this.map
        }];

        this.callParent();

        this.previewMap = this.down('vector-map-export-crop-preview-map');

        this.on({
            move: this.refresh,
            resize: this.refresh
        });
    },

    afterRender() {
        this.callParent();

        this.cropBox = this.add({
            xtype: 'vector-map-export-crop-box',
            extent: this.details.getExtent(),
            previewMap: this.previewMap,
            renderTo: this.el,
            x: 0,
            y: 0
        });

        this.refresh();
    },

    refresh() {
        var cropBox = this.cropBox;

        cropBox.show();

        cropBox.setSize({width: this.getWidth(), height: this.getHeight()});

        cropBox.refresh();
    }
});